import type { AlertLevel } from "./serviceMap";

export interface AlertTone {
    /** A line to the firewall, and the traffic along it. */
    stroke: string;
    /** A card's or a pill's outline. */
    border: string;
    /** A node's status line, and its line's pill. */
    text: string;
    /** The square behind a node's icon. */
    icon: string;
    /** The pulsing dot on a node's corner. */
    dot: string;
    /** A dashed stroke drawn with a border: the legend's swatch. */
    dash: string;
}

/**
 * What an alert looks like on the map and its phone list (CTX-1526): critical in the red
 * of the header's pill and the Critical tag, attention in amber, so a VPN that is down is
 * the first thing seen. Whole class names, so Tailwind finds them.
 */
export const ALERT_TONE: Record<AlertLevel, AlertTone> = {
    critical: {
        stroke: "stroke-semantic-fg-danger",
        border: "border-semantic-border-danger-primary",
        text: "text-semantic-text-danger",
        icon: "bg-semantic-bg-danger-secondary text-semantic-text-danger",
        dot: "bg-semantic-fg-danger",
        dash: "border-semantic-fg-danger",
    },
    attention: {
        stroke: "stroke-semantic-fg-warning",
        border: "border-semantic-border-warning-primary",
        text: "text-semantic-text-warning",
        icon: "bg-semantic-bg-warning-secondary text-semantic-text-warning",
        dot: "bg-semantic-fg-warning",
        dash: "border-semantic-fg-warning",
    },
};
